import {createContext, useContext} from "react";

const PreviewDocumentContext = createContext<Document | null>(null);

export const PreviewDocumentProvider = PreviewDocumentContext.Provider;
export const usePreviewDocument = () => useContext(PreviewDocumentContext);
